<template>
  <section class="introduction-wrap" v-parallax>
    <v-page v-slide-up-in v-parallax-background>
      <v-preface-conclusion
        :data="pageDataItem.page0.data"
        bg="images/introduction/bg-0.jpg|useWebp=false"
        :name="$TL.preface"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content
        :html="
          pageDataItem.page1.data.content + pageDataItem.page2.data.content
        "
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {};
  },
  created() {
    this.pageDataItem = this.schema["introduction"].item;
  },
};
</script>

<style lang="scss">
.introduction-wrap {
  .v-page {
    position: relative;
  }

  .v-page-content {
    .text-content-wrap {
      .text-content {
        padding-bottom: 0;
      }
    }
  }
}
</style>
